import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { getOrderDetailProducts, getOrderStatusList } from '@/services/order/orderDetail';
import { toThousandslsFilter } from "@/filters/";
export default {
  name: 'orderDetailProduct',
  i18n: require('../i18n-orderDetail'),
  props: {
    orderInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    var columnsAgent = [{
      //传票番号
      title: this.$t('orderDetailProduct.expressNo'),
      dataIndex: 'expressNo',
      key: 'expressNo',
      scopedSlots: {
        customRender: 'expressNo'
      }
    }, {
      //传票金额
      title: this.$t('orderDetailProduct.expressNoAmount'),
      dataIndex: 'expressNoAmount',
      key: 'expressNoAmount',
      scopedSlots: {
        customRender: 'expressNoAmount'
      }
    }];
    return {
      orderId: "",
      productInfo: {},
      orderStatusList: [],
      oldProductList: [],
      isTableLoading: false,
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      agentTitle: this.$t('orderDetailProduct.bundleAgent'),
      agentVisible: false,
      agentData: [],
      columnsAgent: columnsAgent,
      orderStatus: undefined,
      anchorList: ['lengcang', 'changwen', 'lengdong']
    };
  },
  computed: {
    columns: function columns() {
      var columns = [{
        //商品编号
        title: this.$t('orderDetailProduct.productNo'),
        dataIndex: 'productNo',
        key: 'productNo',
        width: 100
      }, {
        //商品名称
        title: '商品信息',
        dataIndex: 'productName',
        key: 'productName',
        scopedSlots: {
          customRender: 'productName'
        }
      },
      // 原价
      // {
      // 	title: this.$t('orderDetailProduct.price'),
      // 	dataIndex: 'price',
      // 	key: 'price',
      // 	width: 120,
      // 	scopedSlots: { customRender: 'price' },
      // 	align: 'right'
      // },

      // 售卖方式
      {
        title: this.$t('orderDetailProduct.sellWay'),
        dataIndex: 'caseOrItem',
        key: 'caseOrItem',
        width: 120,
        scopedSlots: {
          customRender: 'caseOrItem'
        },
        align: 'right'
      }, {
        //商品数量
        title: this.$t('orderDetailProduct.productNum'),
        dataIndex: 'productNum',
        key: 'productNum',
        width: 100,
        align: 'right'
      }
      //获取积分
      // {
      // 	title: this.$t('orderDetailProduct.getPointNum'),
      // 	dataIndex: 'getPointNum',
      // 	key: 'getPointNum',
      // 	width: 100,
      // 	align: 'right'
      // },
      ];
      return columns;
    }
  },
  mounted: function mounted() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    this.orderId = this.$route.query.id;
    this.loadData();
    this.loadOrderStatusList();
  },
  methods: {
    formatMoney: function formatMoney(num) {
      return localStorage.leftCurrencySymbol + toThousandslsFilter(num) + localStorage.rightCurrencySymbol;
    },
    loadData: function loadData() {
      var _this = this;
      getOrderDetailProducts({
        orderId: this.orderId
      }).then(function (response) {
        if (response.data.code == 200) {
          _this.productInfo = response.data.data;
          console.log(_this.productInfo, '11111');
          // this.orderStatus = this.productInfo.subOrderVoList[0].orderStatus
          // if(this.productInfo.isOldOrder == 1){
          // 	this.loadOldData();
          // }
        }
      });
    },
    loadOldData: function loadOldData() {
      this.isTableLoading = true;
      var tempProductList = [];
      for (var orderChannelKey in this.productInfo.subOrderVoList) {
        var orderChannel = this.productInfo.subOrderVoList[orderChannelKey];
        if (orderChannel && orderChannel.transportList && orderChannel.transportList.length > 0) {
          for (var temperatureKey in orderChannel.transportList) {
            var tempTemperature = orderChannel.transportList[temperatureKey];
            if (tempTemperature && tempTemperature.productList && tempTemperature.productList.length > 0) {
              for (var productKey in tempTemperature.productList) {
                var tempProduct = tempTemperature.productList[productKey];
                if (tempProduct) {
                  tempProductList.push(tempProduct);
                }
              }
            }
          }
        }
      }
      this.oldProductList = tempProductList;
      this.isTableLoading = false;
    },
    loadOrderStatusList: function loadOrderStatusList() {
      var _this2 = this;
      getOrderStatusList(this.orderId).then(function (response) {
        if (response.data.code == 200) {
          _this2.orderStatusList = response.data.data;
        }
      });
    },
    getStatus: function getStatus(Status) {
      console.log(Status, 'sssssss');
      // return this.$t(`public.orderStatus${Status.orderStatus}`) + "　" + Status.createTime;
      return (Status.orderStatus == 1 ? this.$t('public.orderStatus2') : Status.orderStatus == 2 ? this.$t('public.orderStatus99') : this.$t('public.orderStatus7')) + "　" + Status.createTime;
    },
    goAgentAmount: function goAgentAmount(agdata) {
      this.agentVisible = true;
      this.agentData = agdata;
    },
    handleClick: function handleClick(row) {
      var element = document.getElementById(row.name);
      if (element) {
        element.scrollIntoView({
          block: 'end',
          behavior: 'smooth',
          alignToTop: 'false'
        });
      } else {
        var newLo = this.$router.resolve({
          name: 'orderDetail',
          query: {
            id: 910290,
            activeKey: 2
          }
        });
        window.open(newLo.href, '_blank');
      }
      this.agentVisible = false;
    }
  }
};